import { useEffect, useState } from "react";
import { api, absFile } from "@/lib/api";
import { themeFor } from "@/lib/themes";
import { EventDecor, Squiggle } from "@/components/Motifs";

export default function DressCode() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/public/events").then((r) => setEvents(r.data || [])); }, []);
  return (
    <div data-testid="dresscode-page">
      <section className="bg-[#FFF9F0] grain overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28 grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <div className="kicker text-[#FF6657] rise">The NiGi lookbook · Issue 01</div>
            <h1 className="font-display text-6xl md:text-[8rem] leading-[0.85] tracking-[-0.04em] mt-4 rise d1">The assignment:<br /><span className="italic text-[#A62D58]">Look fabulous.</span></h1>
          </div>
          <div className="lg:col-span-4 font-hand text-2xl rise d2">Colours are inspiration, not a rule. The only real dress code: come ready to celebrate.</div>
        </div>
        <div className="max-w-7xl mx-auto px-5 md:px-10 pb-10 flex flex-wrap gap-3">
          {events.map((e) => {
            const t = themeFor(e.slug);
            return <a key={e.slug} href={`#${e.slug}`} data-testid={`look-jump-${e.slug}`} className="btn-pop rounded-full px-5 py-2.5 kicker" style={{ background: t.bg, color: t.fg }}>{e.name}</a>;
          })}
        </div>
      </section>
      {events.map((e, i) => <Look key={e.slug} e={e} i={i} />)}
    </div>
  );
}

function Look({ e, i }) {
  const t = themeFor(e.slug);
  const imgs = (e.moodboard?.length ? e.moodboard : t.moodboard).slice(0, 3);
  const colors = e.dress_code_colors?.length ? e.dress_code_colors : t.palette;
  return (
    <section id={e.slug} data-testid={`look-${e.slug}`} className="relative overflow-hidden scroll-mt-20" style={{ background: t.bg, color: t.fg }}>
      <EventDecor slug={e.slug} t={t} page />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 min-w-0">
          <div className="kicker" style={{ color: t.accent }}>Look 0{i + 1} · {e.name}</div>
          <h2 className={`text-4xl sm:text-5xl md:text-7xl leading-[0.95] mt-4 break-words ${t.titleClass}`}>{e.dress_code || "Dress to celebrate"}</h2>
          <div className="mt-8">
            <div className="kicker opacity-70 mb-3">Colour inspo</div>
            <div className="flex gap-3">{colors.map((c) => <span key={c} title={c} className="w-11 h-11 rounded-full border-2" style={{ background: c, borderColor: t.fg }} />)}</div>
          </div>
          <div className="grid sm:grid-cols-2 gap-6 mt-10">
            <Note label="For her" accent={t.accent}>{e.styling_women || t.women}</Note>
            <Note label="For him" accent={t.accent}>{e.styling_men || t.men}</Note>
          </div>
          <p className="font-hand text-2xl mt-10 flex items-center gap-3" style={{ color: t.accent }}><Squiggle width={56} className="-scale-x-100" />{e.styling_note || t.note}</p>
        </div>
        <div className="lg:col-span-7 min-w-0">
          <div className="flex md:grid md:grid-cols-2 gap-5 overflow-x-auto md:overflow-visible snap-x snap-mandatory no-scrollbar -mx-5 px-5 md:mx-0 md:px-0">
            {imgs.map((src, k) => (
              <figure key={k} className={`shrink-0 w-[70vw] sm:w-[45vw] md:w-auto snap-center overflow-hidden border-2 ${k === 0 ? "md:row-span-2 h-[420px] md:h-[600px]" : "h-[420px] md:h-[290px]"}`} style={{ borderColor: t.fg, transform: `rotate(${[-1.5, 1.5, -0.8][k]}deg)` }}>
                <img src={absFile(src)} alt={`${e.name} outfit inspiration ${k + 1}`} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </figure>
            ))}
          </div>
          <div className="md:hidden font-hand text-lg mt-3 opacity-70">swipe the moodboard →</div>
        </div>
      </div>
    </section>
  );
}

function Note({ label, accent, children }) {
  return (
    <div className="border-t-2 pt-4" style={{ borderColor: accent }}>
      <div className="kicker" style={{ color: accent }}>{label}</div>
      <p className="mt-2 leading-relaxed">{children}</p>
    </div>
  );
}
